import { render, staticRenderFns } from "./TrainingInfo.vue?vue&type=template&id=0d3a0664"
import script from "./TrainingInfo.vue?vue&type=script&lang=js"
export * from "./TrainingInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports